import React from 'react'

function SectionTitle({ children }) {
  return <h2 className="mb-4 text-lg font-semibold text-gray-800">{children}</h2>
}

export default SectionTitle
